export default "/images/ico-del.svg?7868dd9e6facf239e824fa2fe0e334f2";